<div class="cours-card" (click)="handleClick()">{{title}}</div>
